var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5H4.5V4V2C4.5 1.17314 5.17314 0.5 6 0.5H12C12.8269 0.5 13.5 1.17314 13.5 2V4V4.5H14H17.5V5.5H16H15.5V6V18C15.5 18.8269 14.8269 19.5 14 19.5H4C3.17314 19.5 2.5 18.8269 2.5 18V6V5.5H2H0.5V4.5H4ZM6 1.5H5.5V2V4V4.5H6H12H12.5V4V2V1.5H12H6ZM14 18.5H14.5V18V6V5.5H14H4H3.5V6V18V18.5H4H14Z",
    stroke: "#F46A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e799bf58b3285ca1a015a010820d6990.svg";
export { ForwardRef as ReactComponent };